module.exports = __webpack_public_path__ + "assets/img/0fc0a2d1bf1536fb0b4e2a0f0fe4b044.svg";